(function () {
    'use strict';

    angular
        .module('app')
        .factory('hubFactory', hubFactory);

    hubFactory.$inject = ['$rootScope', '$state', '$timeout', '$interval', '$injector', '$q'];

    function hubFactory($rootScope, $state, $timeout, $interval, $injector, $q) {

        //console.log("PL - in hubFactory");

        var factory = this;
        factory.connectionId = "testid";
        function backEndFactory(hubName, onConnectedCB) {

            //console.log("PL - in backEndFactory");
            
            var connection = $.hubConnection('/Synergis.WebApi'); 
            connection.logging = true;
            var proxy = connection.createHubProxy(hubName);
            var service = {
                on: on,
                userId: "",
                connectionId: "",
                invoke: invoke,
                start: start,
                stop: stop,
                connected: false,
                reconnecting: false,
            };

            function start(params) {
                var deferred = $q.defer();
                //console.log("PL - in start");
                connection.qs = params;
                connection.start().done(function () {
                    onConnected();
                    deferred.resolve();
                });
                return deferred.promise;
            }

            function stop() {
                connection.stop();
                service.connected = false;
            }


            function onConnected() {
                service.reconnecting = false;
                var loginService = $injector.get('loginService');
                loginService.log("Connected to SignalR. Connection Id: " + connection.id);
                service.connectionId = connection.id;
                service.connected = true;
                connection.disconnected(onDisconnected);
                proxy.invoke("hello");
                connection.error(onError);
                connection.reconnected(onReconnected);
                connection.reconnecting(onReconnecting);

                connection.connectionSlow(onConnectionSlow);
                if (onConnectedCB) {
                    onConnectedCB();
                }
            }

            function onReconnecting() {
                console.log("Reconnecting");
                service.connected = false;
                service.reconnecting = true;
            }

            function onReconnected() {
                service.reconnecting = false;
                service.connected = true;    
                console.log("SignalR Reconnected");
            }

            function onDisconnected() {
                service.connected = false;
                console.log("SignalR Disconnected");
                //we try to reconnect
                console.log("SignalR will attempt to reconnect in 5 secs");
                $timeout(function () {
                    console.log("SignalR reconnecting");
                    connection.start().done(onConnected);
                }, 5000);
            }

            function onConnectionSlow() {
                console.log("SignalR Connection Slow");
            }

            function onError() {
                console.log("SignalR error");
            }
        
            function on(event, callback) {
                proxy.on(event, function (result) {
                    $rootScope.$apply(function () {
                        if (callback) {
                            callback(result);
                        }
                    });
                });
            }

            function invoke(method, data) {
                if (data) {
                    proxy.invoke(method, data).done(function () {
                        //console.log('Invocation of method succeeded');
                    }, function (error) {
                        console.log(error);
                    });
                }
                else {
                    proxy.invoke(method).done(function () {
                        //console.log('Invocation of method succeeded');
                    }, function (error) {
                        console.log(error);
                    });
                }
                
            }
            return service;
        }

        


        return backEndFactory;
    }
})();